export default __webpack_public_path__ + "static/media/magicEdenIcon.df37433f.svg";